export const Bio = {
  name: "Md Mohsin Raja",
  roles: [
    "DevOps / Platform Engineer",
    "Full Stack MERN Developer",
    "CI/CD & Automation Engineer",
    "Cloud & DevSecOps Enthusiast",
  ],
  description:
    "I'm a DevOps-focused Software Engineer with extensive hands-on experience in CI/CD automation, Docker, GitLab CI, Jenkins, and cloud deployments. I’ve successfully built production applications using the MERN stack and FastAPI. I’m continuously advancing my skills in cloud, DevSecOps, and platform engineering, while streamlining workflows, enhancing delivery pipelines, and building reliable, scalable systems.",
  resume:
    "https://drive.google.com/file/d/1xxdEgU4-6rXBni9XOgAq1tTrli-FeK5F/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/md-mohsin-raja-628370244/",
  github: "https://github.com/MohsinKing2002",
  leetcode: "https://leetcode.com/u/MohsinKing2002/",
  instagram: "https://www.instagram.com/mohsinking2002/",
};

export const skills = [
  {
    title: "DevOps",
    skills: [
      {
        name: "GitLab CI/CD",
        image: require("../images/skills/devops/Gitlab.png"),
      },
      {
        name: "GitHub Actions",
        image: require("../images/skills/devops/github-act.png"),
      },
      {
        name: "Jenkins",
        image: require("../images/skills/devops/Jenkins.png"),
      },
      {
        name: "Docker",
        image: require("../images/skills/devops/Docker.png"),
      },
      {
        name: "AWS",
        image: require("../images/skills/devops/aws.png"),
      },
      {
        name: "Ansible",
        image: require("../images/skills/devops/ansible.png"),
      },
      {
        name: "Tyk API-Gateway",
        image: require("../images/skills/devops/tyk.png"),
      },
      {
        name: "SonarQube",
        image: require("../images/skills/devops/SQ.png"),
      },
      {
        name: "Shell Scripting",
        image: require("../images/skills/devops/Shell.png"),
      },
      {
        name: "Nginx",
        image: require("../images/skills/devops/nginx.png"),
      },
      {
        name: "YAML",
        image: require("../images/skills/devops/yaml.png"),
      },
    ],
  },
  {
    title: "Backend & DB",
    skills: [
      {
        name: "Node Js",
        image: require("../images/skills/backend/node.png"),
      },
      {
        name: "Express Js",
        image: require("../images/skills/backend/express.png"),
      },
      {
        name: "FastAPI",
        image: require("../images/skills/backend/fast_api.png"),
      },
      {
        name: "Python",
        image: require("../images/skills/backend/python.png"),
      },
      {
        name: "MongoDB",
        image: require("../images/skills/backend/mongo.png"),
      },
      {
        name: "PostgreSQL",
        image: require("../images/skills/backend/postgresql.png"),
      },
      {
        name: "REST APIs",
        image: require("../images/skills/backend/rest.png"),
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image: require("../images/skills/frontend/react.png"),
      },
      {
        name: "Next Js",
        image: require("../images/skills/frontend/next.png"),
      },
      {
        name: "Vue Js",
        image: require("../images/skills/frontend/vue.png"),
      },
      {
        name: "Redux Toolkit",
        image: require("../images/skills/frontend/redux.png"),
      },
      {
        name: "Tailwind CSS",
        image: require("../images/skills/frontend/tailwind.png"),
      },
      {
        name: "Ant Design",
        image: require("../images/skills/frontend/antd.png"),
      },
      {
        name: "Bootstrap",
        image: require("../images/skills/frontend/bootstrap.jpg"),
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: require("../images/skills/others/git.png"),
      },
      {
        name: "GitHub",
        image: require("../images/skills/others/github.png"),
      },
      {
        name: "GitLab",
        image: require("../images/skills/devops/Gitlab.png"),
      },
      {
        name: "Linux",
        image: require("../images/skills/others/linux.png"),
      },
      {
        name: "Postman",
        image: require("../images/skills/others/postman.png"),
      },
      {
        name: "VS Code",
        image: require("../images/skills/others/vs.jpg"),
      },
      {
        name: "Canva",
        image: require("../images/skills/others/canva.png"),
      },
      {
        name: "Figma",
        image: require("../images/skills/others/figma.png"),
      },
    ],
  },
  {
    title: "Programming",
    skills: [
      {
        name: "JavaScript",
        image: require("../images/skills/frontend/js.png"),
      },
      {
        name: "TypeScript",
        image: require("../images/skills/frontend/Ts.png"),
      },
      {
        name: "Python",
        image: require("../images/skills/backend/python.png"),
      },
      {
        name: "C/C++",
        image: require("../images/skills/cross/cpp.png"),
      },
      {
        name: "Go",
        image: require("../images/skills/others/go.png"),
      },
    ],
  },
];

export const Descriptions = {
  skill:
    "Showcasing the expertise I’ve developed and refined since my second year in college.",
  experience:
    "My path as a software engineer, contributing to various companies and exciting projects.",
  achievement:
    "Highlighting my Hacktoberfest 2022 contributions and certifications in DSA and Backend Development.",
  project:
    "Discover a diverse array of projects, ranging from dynamic web applications to innovative Android apps.",
  education:
    "My educational journey has been one of self-discovery and growth. Here are my academic details.",
  contact:
    "Don't hesitate to get in touch with me for inquiries or opportunities!",
};

// ** TODO **: mention project, achievements etc
export const experiences = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQjLQSGDiHcd6MgJIOI3u9viMKE13is3V1IQ&s",
    role: "Software Developer Intern",
    company: "Ditinex Enterprise",
    website: "https://www.ditinex.com/",
    date: "1st Apr 2023 - 31st Jul 2023",
    projects: ["TaskFollow Backend", "TaskFollow Web"],
    desc: "I enhanced team collaboration and streamlined communication by implementing team member features. I resolved critical bugs, ensuring the software's stability and reliability. Leading a redesign initiative, I worked closely with the design team to create a modern, user-friendly UI. I improved user experience by developing an intuitive navigation system, which significantly reduced task completion time. I quickly learned Figma and new frameworks to contribute effectively to the design update process. My tech stack included NodeJs, ExpressJs, MongoDB, NextJs, ReactJs, TailwindCSS, and Redux/Redux Toolkit.",
    skills: [
      "Node Js",
      "Express Js",
      "Mongo DB",
      "Next Js",
      "React Js",
      "Redux",
      "Tailwind Css",
      "Figma",
    ],
    doc: {
      img: require("../images/docs/internship.jpg"),
      link: "https://drive.google.com/file/d/1G4GLI2Fqw6moR0sYt7fSwNr_PIwt584i/view?usp=sharing",
    },
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQjLQSGDiHcd6MgJIOI3u9viMKE13is3V1IQ&s",
    role: "Full Stack Developer",
    company: "Ditinex Enterprise",
    website: "https://www.ditinex.com/",
    date: "1st Aug 2023 - 20th Jul 2024",
    projects: [
      "HS Med Billing",
      "Financial Dashboard",
      "Taste of Persia",
      "SiteMaster Apk",
    ],
    desc: "I have worked as a Full-stack Developer on several projects. For the Financial Dashboard at Health Service LLC, I collaborated with design and backend teams to integrate APIs, fix critical bugs, and add new features, all aimed at enhancing the user experience. I also worked on the restaurant website, Taste of Persia, where I developed an attractive user interface and essential functionalities like orders, payment gateways, and an admin dashboard. My tech stack for these projects included NextJs, NodeJs, ReactJs, ExpressJs, MongoDB, TailwindCSS, and Redux Toolkit. Additionally, as an Expo React Native Developer, I redesigned the SiteMaster app, integrating APIs, fixing bugs, and adding new features to improve the overall user experience.",
    skills: [
      "Node Js",
      "Express Js",
      "Mongo DB",
      "Next Js",
      "React Js",
      "Redux",
      "Square Payment",
      "Tailwind Css",
      "Figma",
    ],
    doc: {
      img: require("../images/docs/internship.jpg"),
      link: "https://drive.google.com/file/d/1Slmu4s0jl5doK4BMKKej8SOYs09gmjKt/view?pli=1",
    },
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjk2lj5AA7PM_TjyDs8PkyfAkhAa5FoTznP0DTenW7X3Y5GrTVh-3BV8ssuKuJZipQ_j0&usqp=CAU",
    role: "Integration Engineer",
    company: "Tata Consultancy Services",
    website: "https://www.tcs.com/",
    date: "25th Jul 2024 - Present",
    projects: ["Kingfisher PLC"],
    desc: "As an Integration Engineer, I’m involved in migrating CI/CD pipelines from Jenkins to GitLab CI, collaborating with teams to design efficient workflows. I write automation scripts in Bash, Groovy, and YAML to streamline build and deployment processes. I also handle validation, modification, and deployment of manifest files in Tyk API Gateway for API creation. My role includes troubleshooting pipeline issues, optimizing performance, and maintaining documentation. This experience has strengthened my skills in CI/CD, Docker, Automation, and API management in a collaborative environment.",
    skills: [
      "Gitlab CI",
      "CI/CD Pipeline",
      "Docker",
      "SSH",
      "Kubernates (K8s)",
      "Groovy",
      "Jenkins",
      "Shell Scripting",
      "Unit Testing",
      "Agile",
    ],
    doc: "",
  },
];

export const achievements = [
  //leetcode
  // {
  //   title: "LeetCode Badges",
  //   badges: [
  //     {
  //       id: 4,
  //       title: "LC 75 Level 2",
  //       date: "26th Sept 2022",
  //       image: require("../images/achievements/lc/LC_75_2.png"),
  //       link: null,
  //     },
  //     {
  //       id: 5,
  //       title: "LC 75 Level 1",
  //       date: "17th Aug 2022",
  //       image: require("../images/achievements/lc/LC_75_1.png"),
  //       link: null,
  //     },
  //     {
  //       id: 6,
  //       title: "Algorithm II",
  //       date: "5th Sept 2022",
  //       image: require("../images/achievements/lc/algorithm_2.png"),
  //       link: null,
  //     },
  //     {
  //       id: 7,
  //       title: "Algorithm I",
  //       date: "14th Aug 2022",
  //       image: require("../images/achievements/lc/algorithm_1.png"),
  //       link: null,
  //     },
  //     {
  //       id: 8,
  //       title: "Data Structure I",
  //       date: "20th Sept 2022",
  //       image: require("../images/achievements/lc/DS_1.png"),
  //       link: null,
  //     },
  //     {
  //       id: 9,
  //       title: "50 Days 2024",
  //       date: "10th Sept 2024",
  //       image: require("../images/achievements/lc/50Qs_2024.png"),
  //       link: null,
  //     },
  //   ],
  // },

  //certifications
  {
    title: "Certificates",
    badges: [
      {
        id: 0,
        title: "CodeVita Session XI",
        date: "March 2024",
        image: require("../images/achievements/certificates/codevita.png"),
        link: "https://drive.google.com/file/d/1SQDRu9Kqx29M3vEqvHjJ_h430ytwt7DY/view?usp=sharing",
      },
      {
        id: 1,
        title: "GFG DSA Bootcamp",
        date: "Oct 2022",
        image: require("../images/achievements/certificates/gfg_dsa.png"),
        link: "https://drive.google.com/file/d/1zXJToZW5N73hGFdgyg5nQqoRBTwSyrYk/view?usp=sharing",
      },
      {
        id: 2,
        title: "Back-End GDSC",
        date: "Sept 2022",
        image: require("../images/achievements/certificates/backend_google.png"),
        link: "https://drive.google.com/file/d/1P21CYfjKoSs1LeKlqmRqhVsVgDywaDVG/view?usp=sharing",
      },
      {
        id: 3,
        title: "Back-End MLSA",
        date: "Sept 2022",
        image: require("../images/achievements/certificates/backend_ms.png"),
        link: "https://drive.google.com/file/d/1P5cdMND78wdD8-1I1fplwRwOsnT_13Db/view?usp=sharing",
      },
    ],
  },

  //hactober fest
  {
    title: "Hacktoberfest 2022",
    badges: [
      {
        id: 0,
        title: "Registration Badge",
        date: "25th Oct 2022",
        image: require("../images/achievements/hf_22/hf_reg.png"),
        link: "https://www.holopin.io/userbadge/cl9ojs4vj226008l45pp0gfmj",
      },
      {
        id: 1,
        title: "HF'22: Level 1",
        date: "25th Oct 2022",
        image: require("../images/achievements/hf_22/cont_L1.png"),
        link: "https://www.holopin.io/@mohsinking2002#",
      },
      {
        id: 2,
        title: "HF'22: Level 2",
        date: "25th Oct 2022",
        image: require("../images/achievements/hf_22/cont_L2.png"),
        link: "https://www.holopin.io/@mohsinking2002#",
      },
      {
        id: 3,
        title: "HF'22: Level 3",
        date: "25th Oct 2022",
        image: require("../images/achievements/hf_22/cont_L3.png"),
        link: "https://www.holopin.io/@mohsinking2002#",
      },
      {
        id: 4,
        title: "HF'22: Level 4",
        date: "26th Oct 2022",
        image: require("../images/achievements/hf_22/cont_L4.png"),
        link: "https://www.holopin.io/@mohsinking2002#",
      },
      {
        id: 5,
        title: "Surfer Moby Dock",
        date: "4th Dec 2022",
        image: require("../images/achievements/hf_22/docker.png"),
        link: "https://www.holopin.io/userbadge/cla25nnev1075808l0vsc7ovsz",
      },
    ],
  },

  // //github
  // {
  //   title: "GitHub Badges",
  //   badges: [
  //     {
  //       id: 1,
  //       title: "Pull Shark Badge",
  //       date: "18th Oct 2022",
  //       image: require("../images/achievements/github/yolo.png"),
  //       link: null,
  //     },
  //     {
  //       id: 2,
  //       title: "YOLO Badge",
  //       date: "19th Apr 2024",
  //       image: require("../images/achievements/github/pull_shark.png"),
  //       link: null,
  //     },
  //   ],
  // },
];

export const education = [
  {
    id: 0,
    img: require("../images/education/mp.png"),
    school: "Shitgram Vidyabhaban High School, North Dinajpur, WB",
    date: "2016 - 2018",
    grade: "84.71%",
    degree: "X, (WBBSE)",
  },
  {
    id: 1,
    img: require("../images/education/hs.png"),
    school: "Kantabari Adibashi High School(H.S), South Dinajpur, WB",
    date: "2018 - 2020",
    grade: "90%",
    degree: "XII, PCM,(WBCHSE)",
  },
  {
    id: 2,
    img: require("../images/education/aliah.png"),
    school: "Aliah University, Kolkata, WB",
    date: "2020 - 2024",
    grade: "7.8 CGPA",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
];

//Email js credentials
export const EmailJs = {
  service_id: process.env.REACT_APP_EMAIL_SERVICE_ID,
  template_id: process.env.REACT_APP_EMAIL_TEMPLATE_ID,
  public_key: process.env.REACT_APP_EMAIL_PUBLIC_KEY,
};

// ** TODO **: add devops project, and refactor all.
//In project's have to fix the description
export const projects = [
  /*
  //taskfollow
  {
    id: 0,
    title: "TaskFollow",
    date: "Apr 2023 - May 2024",
    description:
      "TaskFollow enhances customer-business engagement by allowing businesses to manage tasks and related milestones, assign them to team members, and keep customers updated. Customers can monitor these activities on the platform. For the MVP launch, I redesigned the website, developed team member functionalities, fixed bugs, improved processing time, and added chat features for seamless communication between businesses and customers.",
    image: require("../images/projects/taskfollow.png"),
    tags: [
      "Node Js",
      "React Js",
      "Next Js",
      "Express Js",
      "Mongo DB",
      "Twillio CSS",
      "Antd",
      "Tailwind",
      "Redux",
      "Rest APIs",
      "Nodemailer",
    ],
    category: "web app",
    github: "https://github.com/AAbdelraouf/TaskFollow_web",
    webapp: "https://taskfollow.net/",
    member: [
      {
        name: "Md Mohsin Raja",
        img: require("../images/mohsin.png"),
        linkedin: Bio.linkedin,
        github: Bio.github,
      },
      {
        name: "Asif Akram",
        img: require("../images/teams/asifDa.jpeg"),
        linkedin: "https://www.linkedin.com/in/asif-akram-b63099145/",
        github: null,
      },
      {
        name: "Tohidujaman Hoque",
        img: require("../images/teams/tj.jpeg"),
        linkedin: "https://www.linkedin.com/in/tohidujjaman-hoque/",
        github: "https://github.com/upasana0710",
      },
    ],
  },
  
  //sitemaster
  {
    id: 1,
    title: "SiteMaster APK",
    date: "Aug 2023 - Dec 2023",
    description:
      "SiteMaster APK, built with Expo React Native, monitors construction data including site creation, material usage, labor details, and vendor transactions. For the MVP, I redesigned the app by continously collabrating with design team and enhanced features like editing site details, adding/uploading images, and visualizing payment and expenditure data through detailed graphs.",
    image: require("../images/projects/sitemaster.png"),
    tags: [
      "React Native",
      "Expo",
      "React Js",
      "Playstore",
      "React Native Paper",
      "Cross Platform",
      "Tailwind CSS",
    ],
    category: "android app",
    github: null,
    webapp:
      "https://play.google.com/store/apps/details?id=com.sitemaster.sitemasterapp&pcampaignid=web_share",
    member: [
      {
        name: "Md Mohsin Raja",
        img: require("../images/mohsin.png"),
        linkedin: Bio.linkedin,
        github: Bio.github,
      },
      {
        name: "Sushobhan Mahato",
        img: require("../images/teams/sm.jpeg"),
        linkedin: "https://www.linkedin.com/in/sushobhan-mahato-4026b121b/",
        github: "https://github.com/upasana0710",
      },
    ],
  },

  //crud app
  {
    id: 5,
    title: "CRUD App",
    date: "Aug 2022",
    description:
      "This MERN stack application provides complete CRUD functionalities for user profiles, allowing users to create, read, update, and delete their profiles while viewing others'. Built with Redux, Axios, and React-Bootstrap, it ensures smooth data handling and a sleek interface. JWT authentication secures user identity throughout the app.",
    image: require("../images/projects/crud.png"),
    tags: [
      "Node Js",
      "React Js",
      "Mongo DB",
      "Express Js",
      "Redux/Redux-toolkit",
      "Bootstrap",
      "React-Bootstrap",
      "Rest APIs",
    ],
    category: "web app",
    github: "https://github.com/MohsinKing2002/MERN-CRUD",
    webapp: null,
  },

  //movieflix
  {
    id: 12,
    title: "MovieFlix",
    date: "Mar 2023 - Apr 2023",
    description:
      "MovieFlix, a MERN stack website, allows users to browse TV shows and movies, sourced from The Movie Database (TMDb). Users can sign up, log in, like movies, and add them to a 'Watch Later' list. The platform supports movie searches and video playback, providing a seamless and engaging entertainment experience.",
    image: require("../images/projects/movie.png"),
    tags: [
      "Node Js",
      "Express Js",
      "React Js",
      "Mongo DB",
      "Redux",
      "JWT Auth",
      "TMDb API",
      "Bootstrap",
      "React-Bootstrap",
      "Video Player",
    ],
    category: "web app",
    github: "https://github.com/MohsinKing2002/MovieFlix",
    webapp: "https://mk-movieflix.netlify.app/",
  },
  */

  //diesease prediction
  {
    id: 2,
    title: "Disease Prediction",
    date: "Feb 2024 - Jun 2024",
    description:
      "The Disease Prediction System is a website designed to predict diseases based on selected symptoms. Using Flask and models like Naive Bayes, Random Forest, and SVC, the system processes symptoms and predicts the likely disease, with the final output determined by the mode of predictions. Built with React.js and Tailwind CSS, this was my final year project, showcasing advanced machine learning integration",
    image: require("../images/projects/dp.png"),
    tags: [
      "React Js",
      "Tailwind CSS",
      "Flask",
      "Pickle",
      "Python",
      "Machine Learning",
      "Flowbite UI",
      "Rest APIs",
    ],
    category: "web app",
    github: "https://github.com/MohsinKing2002/Disease-Prediction",
    webapp: "https://mk-dp.netlify.app/",
    member: [
      {
        name: "Md Mohsin Raja",
        img: require("../images/mohsin.png"),
        linkedin: Bio.linkedin,
        github: Bio.github,
      },
      {
        name: "SK Asif",
        img: require("../images/teams/sk.jpeg"),
        linkedin: "https://www.linkedin.com/in/sk-asif-12baa820b/",
        github: null,
      },
    ],
  },

  //quick shop
  {
    id: 11,
    title: "QuickShop",
    date: "June 2024 - Jul 2024",
    description:
      "The Shopping App, built with React Native (Expo) and Tailwind CSS, utilizes the Fake Store API to provide users with a seamless shopping experience. On the home page, users can browse a list of different items, search for products, and explore categories. Clicking on an item opens its detailed page, showcasing product descriptions, prices, and reviews, as well options like Add to cart and Order now. User can Order items etc.",
    image: require("../images/projects/shopping.jpeg"),
    tags: [
      "React Native",
      "Expo",
      "UI/UX",
      "Async Storage",
      "FakeStore API",
      "Tailwind Css",
      "React Native Paper",
      "Cross Platform",
    ],
    category: "android app",
    github: "https://github.com/MohsinKing2002/Expo-Shopping-App",
    webapp: "https://www.youtube.com/watch?v=EjQwa7wajy8&t=31s",
  },

  //connectify
  {
    id: 10,
    title: "Connectify",
    date: "Jun 2024 - Jul 2024",
    description:
      "Connectify is a React Native (Expo) app enhanced with Tailwind CSS and custom APIs, offering a seamless social media experience. It includes six screens: Home:- where users see posts from those they follow and suggested users. Explore:- for searching users or posts, viewing trending posts, and top profiles. Create:- Post, allowing users to create and preview new posts. Account:- displaying user details, followers, following, and personal posts. Conversations:- listing users they’ve chatted with. and Chatting:- showing detailed chat history with selected users.",
    image: require("../images/projects/connect.jpeg"),
    tags: [
      "React Native",
      "Expo",
      "UI/UX",
      "Data APIs",
      "Tailwind Css",
      "React Native Paper",
      "Cross Platform",
    ],
    category: "android app",
    github: "https://github.com/MohsinKing2002/Connectify",
    webapp: "https://www.youtube.com/watch?v=bihd86RLdhY",
  },

  //burger king
  {
    id: 3,
    title: "Burger King",
    date: "Nov 2022 - Dec 2022",
    description:
      "Burger King is a full-stack MERN application. That allow users to browse a list of burger menus, add items to the cart, select a delivery address, and choose a payment method (cash on delivery or online payment via Razorpay, UPI, or card). Integrated with Google Auth for secure login, this app offers a seamless online ordering experience.",
    image: require("../images/projects/burger.png"),
    tags: [
      "React Js",
      "Mongo DB",
      "Node Js",
      "Express Js",
      "Redux/Redux-toolkit",
      "Google Authentication",
      "Rest APIs",
    ],
    category: "web app",
    github: "https://github.com/MohsinKing2002/BurgerKing",
    webapp: null,
  },

  //funtastic v gram
  {
    id: 4,
    title: "Social Media App",
    date: "Sep 2022 - Oct 2022",
    description:
      "FuntasticVgram is a web application, that enables users to create, read, update, and delete posts with media uploads, likes, and comments. It features a responsive UI and robust security with bcrypt.js for password hashing and JWT for authentication. Cloudinary handles media storage, while Socket.io powers group and 1v1 chat functionalities. Technologies used include Node.js, Express.js, React.js, MongoDB, Redux, Redux-toolkit, and Bootstrap.",
    image: require("../images/projects/social.png"),
    tags: [
      "React Js",
      "Mongo DB",
      "Node Js",
      "Express Js",
      "Redux/Redux-toolkit",
      "Rest APIs",
      "React-Bootstrap",
      "Bootstrap",
    ],
    category: "web app",
    github: "https://github.com/MohsinKing2002/mk-funtasticVgram",
    webapp: null,
  },

  //quiz app
  {
    id: 6,
    title: "Quiz App",
    date: "Feb 2024",
    description:
      "The Quiz App, developed with React Native (Expo), Tailwind Css and Open Trivia DB API, allows users to enter their name, select the number of questions, difficulty level, and category before starting the quiz. Users are presented with multiple-choice questions based on their selections and can choose to answer or skip. After all questions are visited, a result page displays the user's name, total questions, answered questions, skipped questions, and total marks scored.",
    image: require("../images/projects/quiz.png"),
    tags: [
      "React Native",
      "Expo",
      "Type Script",
      "Trivia API",
      "Tailwind Css",
      "React Native Paper",
      "Cross Platform",
    ],
    category: "android app",
    github: "https://github.com/MohsinKing2002/TS_Quizzy",
    webapp: null,
  },

  // code help
  {
    id: 7,
    title: "Education App",
    date: "Jan 2023",
    description:
      "Code Help Clone, built with React Native (Expo), features a captivating landing page with intuitive navigation and a smooth bottom header for enhanced user engagement. It includes a comprehensive student database managing user details like images, names, emails, and enrolled courses. Additionally, the app showcases a course database with rich content, banner images, and detailed course descriptions, providing users with a thorough overview of available courses.",
    image: require("../images/projects/codehelp.jpeg"),
    tags: [
      "React Native",
      "Expo",
      "React Js",
      "Data API",
      "Axios",
      "UI/UX",
      "CSS",
      "React Navigation",
    ],
    category: "android app",
    github: "https://github.com/MohsinKing2002/codeHelp",
    webapp: "https://expo.dev/@mohsinking2002/online-education-app",
  },

  //crypto king
  {
    id: 8,
    title: "Crypto App",
    date: "Jan 2023",
    description:
      "Crypto App, built with React.js and Material-UI, provides users with real-time cryptocurrency data from the CoinGecko API. Users can view coins ranked by popularity, track exchanges, and analyze 24-hour data on profit/loss and market captures, all within a single, streamlined application. Chart Js enhances the UI for a visually appealing experience.",
    image: require("../images/projects/crypto.png"),
    tags: [
      "React Js",
      "Axios",
      "Materail UI",
      "React Icons",
      "Realtime Data",
      "Crypto API",
    ],
    category: "web app",
    github: "https://github.com/MohsinKing2002/Crypto-King",
    webapp: "https://mk-cryptoking.netlify.app/",
  },

  //note app
  {
    id: 9,
    title: "Note App",
    date: "Aug 2022 - Sep 2022",
    description:
      "The Note App, developed with the MERN stack, offers users CRUD functionalities such as registration, profile updates, and deletion. It features a responsive and interactive UI, allowing users to create, edit, and delete their notes. Additionally, users can browse friends' notes if they are connected within the app. Security is ensured with JWT authentication and bcrypt for password hashing.",
    image: require("../images/projects/note.png"),
    tags: [
      "Node Js",
      "Express Js",
      "React Js",
      "Mongo DB",
      "JWT Auth",
      "CRUD Operations",
      "Bootstrap",
      "React-Bootstrap",
    ],
    category: "web app",
    github: "https://github.com/MohsinKing2002/mern-note-app",
    webapp: "https://mk-mern-note-app.herokuapp.com",
  },
];
